const KINDLY_CHRISTIAN_DOMAINS = [
  'kindlychristian.io',
  'kindlychristian.dev.lis-call.com',
  'kindlychristian.stage.lis-call.com',
];

function isKindlyChristianDomain(): boolean {
  const hostname = window.location.hostname;
  return KINDLY_CHRISTIAN_DOMAINS.some((domain) => hostname === domain || hostname.endsWith(`.${domain}`));
}

/** Resolves the Keycloak public client id string for MWA (matches backend ClientID enum values). */
export function resolveMwaKeycloakClientId(): string {
  const christian = process.env.REACT_APP_KEYCLOAK_IDP_CLIENT_ID_CHRISTIAN;
  const useChristian =
    process.env.REACT_APP_KEYCLOAK_USE_CHRISTIAN_CLIENT === 'true'
      ? Boolean(christian)
      : isKindlyChristianDomain() && Boolean(christian);
  if (useChristian) {
    return christian!;
  }
  return process.env.REACT_APP_KEYCLOAK_IDP_CLIENT_ID!;
}
